var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-container my-5 py-5 text-center d-flex"},[_c('div',{staticClass:"loading-spinner mx-auto"})])}]

export { render, staticRenderFns }